/* eslint-disable import/prefer-default-export */

import { AGENCIES } from 'src/store/ActionTypes';

export const fetchAgencies = (query) => ({
  type: AGENCIES.FETCH_AGENCIES,
  payload: query,
});

export const addAgency = (agency) => ({
  type: AGENCIES.ADD_AGENCY,
  payload: agency,
});

export const deleteAgency = (agencyId) => ({
  type: AGENCIES.DELETE_AGENCY,
  payload: agencyId,
});
